<template>
<div class="chapter">
<div class="inner_page">
      ﻿

<title>What It Used to Be Like</title>
<link href="page-template.xpgt" rel="stylesheet" type="application/vnd.adobe-page-template+xml"/>
<link href="9781429902687.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=utf-8" http-equiv="content-type"/>
<div class="contents" id="con01">
<h2 class="contentsHead" style="text-indent: 0%;"><span class="bold">Contents</span></h2>
<div class="contentsEntry">
<p class="contentsEntryName1" style="margin-left: 5%; text-indent: 0%;"><a href="#/9781429902687_pt01#pt01"><span class="bold">1950s</span></a></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><a href="#/9781429902687_ch01#ch01">1 Spudnuts and Roses</a></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><a href="#/9781429902687_ch02#ch02">2 Love Letters</a></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><span href="#/9781429902687_ch03#ch03" title="Link target outside of Sample">3 To Church We Went</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><span href="#/9781429902687_ch04#ch04" title="Link target outside of Sample">4 Young, Married, with Children</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><span href="#/9781429902687_ch05#ch05" title="Link target outside of Sample">5 A Town Called Paradise</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><span href="#/9781429902687_ch06#ch06" title="Link target outside of Sample">6 Along the Way at Chico State</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryName1" style="margin-left: 5%; text-indent: 0%;"><span href="#/9781429902687_pt02#pt02" title="Link target outside of Sample"><span class="bold">1960s</span></span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><span href="#/9781429902687_ch07#ch07" title="Link target outside of Sample">7 Eureka</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><span href="#/9781429902687_ch08#ch08" title="Link target outside of Sample">8 Arcata</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><span href="#/9781429902687_ch09#ch09" title="Link target outside of Sample">9 Iowa City</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><span href="#/9781429902687_ch10#ch10" title="Link target outside of Sample">10 Sacramento</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><span href="#/9781429902687_ch11#ch11" title="Link target outside of Sample">11 Palo Alto, Israel, Paris, Hollywood</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryName1" style="margin-left: 5%; text-indent: 0%;"><span href="#/9781429902687_pt03#pt03" title="Link target outside of Sample"><span class="bold">1970s</span></span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><span href="#/9781429902687_ch12#ch12" title="Link target outside of Sample">12 Writing, Teaching, Drinking</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><span href="#/9781429902687_ch13#ch13" title="Link target outside of Sample">13 That August</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><span href="#/9781429902687_ch14#ch14" title="Link target outside of Sample">14 Maelstrom</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><span href="#/9781429902687_ch15#ch15" title="Link target outside of Sample">15 “<em class="italic">Will You Please Be Quiet, Please?”</em></span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><span href="#/9781429902687_ch16#ch16" title="Link target outside of Sample">16 Twisted Fork in the Road</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><span href="#/9781429902687_ch17#ch17" title="Link target outside of Sample">17 Parting and Apart</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryName1" style="margin-left: 5%; text-indent: 0%;"><span href="#/9781429902687_pt04#pt04" title="Link target outside of Sample"><span class="bold">1980s</span></span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><span href="#/9781429902687_ch18#ch18" title="Link target outside of Sample">18 Nobody Knows</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryNumber" style="margin-left: 10%; text-indent: 0%;"><span href="#/9781429902687_ch19#ch19" title="Link target outside of Sample">19 Always</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryName1" style="margin-left: 5%; text-indent: 0%;"><span href="#/9781429902687_bm01#bm01" title="Link target outside of Sample"><em class="italic">Chronology: Raymond Carver,</em> 1938–88</span></p></div>
<div class="contentsEntry">
<p class="contentsEntryName" style="margin-left: 5%; text-indent: 0%;"><span href="#/9781429902687_bm02#bm02" title="Link target outside of Sample"><em class="italic">Selected Works of Raymond Carver</em></span></p></div>
<div class="contentsEntry">
<p class="contentsEntryName" style="margin-left: 5%; text-indent: 0%;"><span href="#/9781429902687_ack01#ack01" title="Link target outside of Sample"><em class="italic">Acknowledgments</em></span></p></div>
<div class="contentsEntry">
<p class="contentsEntryName" style="margin-left: 5%; text-indent: 0%;"><span href="#/9781429902687_ind01#ind01" title="Link target outside of Sample"><em class="italic">Index</em></span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429902687_con01.vue?d2ba7940